/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';

/**
 * 
 * @export
 * @interface WebAuthnCreateAttestation
 */
export interface WebAuthnCreateAttestation {
    /**
     * 
     * @type {string}
     * @memberof WebAuthnCreateAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof WebAuthnCreateAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {object}
     * @memberof WebAuthnCreateAttestation
     */
    data?: object;
}



/**
 * Check if a given object implements the WebAuthnCreateAttestation interface.
 */
export function instanceOfWebAuthnCreateAttestation(value: object): value is WebAuthnCreateAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function WebAuthnCreateAttestationFromJSON(json: any): WebAuthnCreateAttestation {
    return WebAuthnCreateAttestationFromJSONTyped(json, false);
}

export function WebAuthnCreateAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebAuthnCreateAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function WebAuthnCreateAttestationToJSON(json: any): WebAuthnCreateAttestation {
    return WebAuthnCreateAttestationToJSONTyped(json, false);
}

export function WebAuthnCreateAttestationToJSONTyped(value?: WebAuthnCreateAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': value['data'],
    };
}

